var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ob-client-section',{attrs:{"type":"comuneClient","label":"Header_3.1"}})
}
var staticRenderFns = []

export { render, staticRenderFns }